import { NgModule } from '@angular/core';
import { HomeComponent } from './home/home.component';
import { ButtonComponent } from './home/button.component';
import { Routes, RouterModule } from '@angular/router';
import { UserComponent } from './user/user.component';
import { TestComponent } from './test/test.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
    { path: '', component: HomeComponent },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [HomeComponent, ButtonComponent, UserComponent, TestComponent],
    exports: [
        RouterModule
    ]
})
export class HomeModule { }